import React, { useState, useEffect } from 'react'; // Make sure useEffect is imported
import { Plus, Brain } from 'lucide-react';
import { useTaskOperations } from '../../hooks/useTaskOperations';
import { useAuth } from '../../hooks/useAuth'; // Add this import

const TaskForm = () => {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ title: '', description: '' });
  const { addTask, isLoading } = useTaskOperations();
  const { currentUser } = useAuth(); // Add this line

  // ADD ONLY THIS useEffect - resets form when user changes
  useEffect(() => {
    setShowForm(false);
    setFormData({ title: '', description: '' });
  }, [currentUser]);

  // ... rest of your existing TaskForm code stays exactly the same
  const handleSubmit = async () => {
    if (!formData.title.trim()) return;
    
    try {
      await addTask(formData);
      setFormData({ title: '', description: '' });
      setShowForm(false);
    } catch (error) {
      console.error('Error in TaskForm:', error);
    }
  };

  const handleCancel = () => {
    setShowForm(false);
    setFormData({ title: '', description: '' });
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
      <h2 className="text-lg font-semibold mb-4 flex items-center">
        <Plus className="w-5 h-5 mr-2 text-blue-600" />
        Add New Task
      </h2>
      
      {showForm ? (
        <div className="space-y-4">
          <input
            value={formData.title}
            onChange={(e) => setFormData(prev => ({ ...prev, title: e.target.value }))}
            placeholder="Task title (e.g., 'Urgent: Complete project proposal')"
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            disabled={isLoading}
          />
          <textarea
            value={formData.description}
            onChange={(e) => setFormData(prev => ({ ...prev, description: e.target.value }))}
            placeholder="Task description (AI will analyze this for priority)"
            className="w-full p-3 border border-gray-300 rounded-lg resize-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            rows="3"
            disabled={isLoading}
          />
          <div className="flex gap-3">
            <button
              onClick={handleSubmit}
              className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center disabled:opacity-50"
              disabled={!formData.title.trim() || isLoading}
            >
              <Brain className="w-4 h-4 mr-2" />
              {isLoading ? 'Adding...' : 'Add & Analyze Priority'}
            </button>
            <button
              onClick={handleCancel}
              className="px-6 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400"
              disabled={isLoading}
            >
              Cancel
            </button>
          </div>
        </div>
      ) : (
        <button
          onClick={() => setShowForm(true)}
          className="w-full p-4 border-2 border-dashed border-gray-300 rounded-lg text-gray-500 hover:border-blue-500 hover:text-blue-600 transition-colors"
        >
          Click to add a new task
        </button>
      )}
    </div>
  );
};

export default TaskForm;